"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgArrows(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12.456.15l.086.074 3.06 3.062a.765.765 0 01-.997 1.155l-.086-.074-1.772-1.774v8.643h8.641l-1.753-1.754a.765.765 0 01-.074-.996l.074-.085a.765.765 0 01.996-.074l.085.074 3.06 3.06a.765.765 0 01.074.995l-.074.086-3.06 3.06a.765.765 0 01-1.155-.997l.074-.085 1.752-1.755h-8.64v8.642l1.773-1.77a.765.765 0 01.996-.074l.085.074a.765.765 0 01.074.996l-.074.086-3.06 3.059a.765.765 0 01-.995.074l-.086-.074-3.06-3.06a.765.765 0 01.997-1.155l.085.074 1.736 1.735v-8.607H2.61l1.755 1.755a.765.765 0 01.074.996l-.074.085a.765.765 0 01-.996.074l-.085-.074-3.06-3.06-.065-.073a.776.776 0 01-.002-.002l.067.076A.768.768 0 010 12v-.016a.77.77 0 01.004-.062L0 12a.77.77 0 01.15-.455l.007-.01a.77.77 0 01.067-.076l3.06-3.06a.765.765 0 011.155.997l-.074.085-1.755 1.754h8.608V2.63L9.483 4.367a.765.765 0 01-.996.074L8.4 4.367a.765.765 0 01-.075-.995l.074-.086L11.46.224a.765.765 0 01.996-.074z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgArrows;
exports.default = _default;